import dayjs from 'dayjs';

export const DASHBOARD_SIDEBAR_STORAGE_KEY = 'beam:dashboard-sidebar-collapsed';

export const getSavedSidebarCollapsed = (storage: Pick<Storage, 'getItem'>) =>
  storage.getItem(DASHBOARD_SIDEBAR_STORAGE_KEY) === 'true';

export const saveSidebarCollapsed = (
  storage: Pick<Storage, 'setItem'>,
  collapsed: boolean,
) => storage.setItem(DASHBOARD_SIDEBAR_STORAGE_KEY, String(collapsed));

export const isWorkspaceSettingsPath = (pathname: string) =>
  pathname.startsWith('/workspace-settings');

export const formatOutOfOfficeTooltip = (endDate?: string) => {
  if (!endDate || !dayjs(endDate).isValid()) return 'Out of office';

  return `Out of office until ${dayjs(endDate).format('MMM D, YYYY')}`;
};

export const shouldShowOutOfOffice = ({
  userStatus,
  hasVacation,
  isLoading,
}: {
  userStatus: boolean;
  hasVacation: boolean;
  isLoading: boolean;
}) => userStatus && (isLoading || hasVacation);
